export const getPaymentsList = (state) => state.payments || [];
